import React from "react";

const ThreePStudents = () => {
  return (
    <div className="bg-black text-white [&_p]:text-white min-h-screen p-4">

      <div className="mx-auto max-w-4xl">

        <h1 className="text-lg lg:text-2xl font-bold text-yellow-200 mb-4">
          👨‍🎓 3P for Students
        </h1>

        <h2 className="text-sm lg:text-lg text-purple-300 mb-4">
          Story of Rahul’s Mistake
        </h2>

        <p className="text-gray-300 mb-4">
          It is <b>8:25 PM</b> in Rahul’s house. Rahul is a Class 9 student.
          After dinner he opens his school diary.
        </p>

        <div className="bg-gray-900 p-3 rounded mb-4">
          <p className="text-gray-200">Math Homework:</p>
          <p className="text-yellow-300">Solve 10 Algebra Questions</p>
        </div>

        <p className="text-gray-300 mb-4">
          Rahul glances at the questions and casually says to himself:
          <span className="text-yellow-200"> “Easy… I’ll finish this in 30 minutes.”</span>
        </p>

        <p className="text-gray-300 mb-4">
          He relaxes for a few minutes and finally starts the homework at 8:30 PM.
        </p>

        <ul className="list-disc list-inside [&_li]:text-gray-200 space-y-1 mb-4">
          <li>Question 1 — Done</li>
          <li>Question 2 — Done</li>
          <li>Question 3 — Suddenly becomes messy</li>
          <li>Rahul erases the page and tries again</li>
          <li>Another mistake</li>
        </ul>

        <p className="text-gray-300 mb-4">
          Now 10 minutes are gone.
        </p>

        <p className="text-gray-300 mb-4">
          Later he opens YouTube to understand the method.
          Another <b>15 minutes gone.</b>
        </p>

        <p className="text-gray-300 mb-4">
          Finally the homework finishes.
        </p>

        <div className="bg-gray-900 p-3 rounded mb-6">
          <p className="text-gray-200">
            What Rahul thought: <span className="text-yellow-300">30 minutes</span>
          </p>
          <p className="text-gray-200">
            Actual time taken: <span className="text-red-300">80 minutes</span>
          </p>
        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Real Damage
        </h2>

        <p className="text-gray-300 mb-4">
          Rahul suddenly remembers something important.
          Tomorrow he has a <b>Science test.</b>
        </p>

        <ul className="list-disc list-inside [&_li]:text-gray-200 space-y-1 mb-6">
          <li>He is tired</li>
          <li>His brain is exhausted</li>
          <li>It is already almost 10 PM</li>
        </ul>

        <p className="text-gray-300 mb-6">
          He studies only for 10 minutes and sleeps.  
          The next day he struggles in the test.
        </p>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Secret Rahul Didn’t Know
        </h2>

        <p className="text-gray-300 mb-4">
          Rahul’s friend Arjun uses something called:
        </p>

        <div className="bg-gray-900 p-3 rounded mb-6">
          <p className="text-yellow-200 font-semibold">
            Think5Whys PTM 3P Method
          </p>
          <p className="text-gray-300 text-sm">
            Three Point Estimation
          </p>
        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          How Arjun Estimated the Same Homework
        </h2>

        <div className="bg-gray-900 p-4 rounded mb-6">

          <table className="w-full text-left text-sm">
            <thead className="text-yellow-200">
              <tr>
                <th>Estimate</th>
                <th>Time</th>
              </tr>
            </thead>

            <tbody className="text-gray-300">
              <tr>
                <td>Optimistic (O)</td>
                <td>30 minutes</td>
              </tr>

              <tr>
                <td>Most Likely (M)</td>
                <td>45 minutes</td>
              </tr>

              <tr>
                <td>Pessimistic (P)</td>
                <td>75 minutes</td>
              </tr>
            </tbody>
          </table>

        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          Think5Whys PTM 3P Calculation
        </h2>

        <div className="bg-gray-900 p-4 rounded mb-4">

          <p className="text-gray-300 mb-2">
            <b>Triangular Estimate</b>
          </p>

          <p className="text-yellow-200 mb-3">
            (30 + 45 + 75) / 3 = 50 minutes
          </p>

          <p className="text-gray-300 mb-2">
            <b>PERT Estimate</b>
          </p>

          <p className="text-yellow-200">
            (30 + 4×45 + 75) / 6 ≈ 48 minutes
          </p>

        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Real Lesson
        </h2>

        <p className="text-gray-300 mb-4">
          Students who guess time usually say:
        </p>

        <p className="text-red-300 mb-4">
          “I thought it would take less time.”
        </p>

        <p className="text-gray-300 mb-4">
          Students who use Think5Whys PTM 3P say:
        </p>

        <p className="text-green-300 mb-6">
          “I planned it.”
        </p>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          Using 3P Beyond Homework
        </h2>

        <ul className="list-disc list-inside [&_li]:text-gray-200 space-y-1 mb-6">
          <li>Getting ready for school</li>
          <li>Preparing for exams</li>
          <li>Completing school projects</li>
          <li>Practicing sports or music</li>
          <li>Traveling to tuition classes</li>
          <li>Helping parents at home</li>
        </ul>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Final Realization
        </h2>

        <p className="text-gray-300 mb-2">
          One day Rahul understood something important:
        </p>

        <p className="text-yellow-200 text-lg">
          “All this time I was guessing… Arjun was calculating.”
        </p>

      </div>
    </div>
  );
};

export default ThreePStudents;